<script setup lang="ts">
import SettingsOffCanvas from "@/components/settings/SettingsOffCanvas.vue";
import { trackPageView } from "@/analytics/app-analytics";
import { useGetStorageInfo } from "@/composable/useStorageQuota";

const { isHighStorageLimit } = useGetStorageInfo();

// Counted with the page views: a header panel is a "page" to the user.
function onOpenSettings() {
  trackPageView("panel-settings");
}
</script>
<template>
  <a
    data-bs-toggle="offcanvas"
    href="#offcanvasSettings"
    @click="onOpenSettings"
    role="button"
    aria-controls="offcanvasSettings"
    class="dr-tooltip"
    :data-tooltip="$t('navbar.settingsTooltip')"
    :aria-label="$t('navbar.settingsTooltip')"
    style="position: relative"
  >
    <el-icon size="18" class="text-dark">
      <i class="bi bi-gear"></i>
    </el-icon>

    <el-icon v-if="isHighStorageLimit" size="1rem" class="absolute-icon-badge">
      <i class="bi-exclamation-triangle-fill text-danger"></i
    ></el-icon>
  </a>
  <SettingsOffCanvas />
</template>

<style scoped>
.absolute-icon-badge {
  position: absolute;
  top: -4px;
  right: -8px;
}
</style>
